import React, { useState } from "react";
import { Col, Row, Select, DatePicker, Button, Radio, Form } from "antd";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { getWithExpiry } from "../../utils/localStorage";
import { LocalStorageKeys } from "../../utils/constant";
import _ from "lodash";
import useTime from "../../hooks/useTime";
import { SearchOutlined } from "@ant-design/icons";

const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterBookingStatistic = (props) => {
  const storage = getWithExpiry(LocalStorageKeys.order_list);
  const [form] = Form.useForm();
  const { formatAsISOString } = useTime();

  const {
    data,
    onFilter,
    setFilter,
    justify,
    colTextSearch,
    loadingFilter,
    setLoadingFilter,
  } = props;
  const intl = useIntl();

  const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
  };

  const createData = (data) => {
    if (data.length) {
      const defaultOption = {
        name: "name",
        col: 4,
        placeholder: "Select",
        data: [],
        type: "multiple",
      };
      return data.map((item) => {
        if (storage?.filter?.filter_name && storage?.filter?.filter_value) {
          const filter_name = storage?.filter?.filter_name;
          const filter_value = storage?.filter?.filter_value;
          if (Array.isArray(filter_name) && Array.isArray(filter_value)) {
            if (item?.name) {
              const index = _.findIndex(
                filter_name,
                (name) => name === item.name
              );
              if (index !== -1) {
                item["defaultValue"] = filter_value[index];
              }
            }
          }
        }

        return {
          ...defaultOption,
          ...item,
          onChange: (value) => onFilter(value, item.name, ""),
        };
      });
    }
    return [];
  };

  const createElement = (data) => {
    var dataElement = createData(data);

    if (dataElement?.length) {
      return dataElement?.map((item, index) => {
        return item.data[0]?.id ? (
          <Col sm={{ span: 10 }} xs={{ span: 24 }} key={index}>
            <Form.Item name={item.name}>
              <Select
                // mode={item.type}
                showSearch
                placeholder={item?.placeholder}
                onChange={item?.onChange}
                style={{ width: "100%" }}
                allowClear={true}
                optionFilterProp="children"
                // filterOption={(input, option) => {
                //   if (typeof option.children !== "string") {
                //     if (option?.children?.props?.id) {
                //       return (
                //         intl
                //           .formatMessage({ id: option?.children?.props?.id })
                //           ?.toLowerCase()
                //           ?.indexOf(input?.toLowerCase()) >= 0
                //       );
                //     } else {
                //       return (
                //         option.value
                //           ?.toLowerCase()
                //           ?.indexOf(input?.toLowerCase()) >= 0
                //       );
                //     }
                //   }
                //   return (
                //     option?.children
                //       ?.toLowerCase()
                //       ?.indexOf(input?.toLowerCase()) >= 0
                //   );
                // }}
                defaultValue={item?.defaultValue}
              >
                {item?.data?.length &&
                  item?.data?.map((option, i) => {
                    return (
                      <Option key={i} value={option?.id ? option?.id : ""}>
                        {option?.start_location?.title} -{" "}
                        {option?.end_location?.title} ({option?.title})
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
        ) : (
          <Col sm={{ span: 4 }} xs={{ span: 24 }} key={index}>
            <Form.Item name={item.name}>
              <Select
                showSearch
                placeholder={item?.placeholder}
                onChange={item?.onChange}
                style={{ width: "100%" }}
                allowClear={true}
                optionFilterProp="children"
                // filterOption={(input, option) => {
                //   if (typeof option.children !== "string") {
                //     if (option?.children?.props?.id) {
                //       return (
                //         intl
                //           .formatMessage({ id: option?.children?.props?.id })
                //           ?.toLowerCase()
                //           ?.indexOf(input?.toLowerCase()) >= 0
                //       );
                //     } else {
                //       return (
                //         option.value
                //           ?.toLowerCase()
                //           ?.indexOf(input?.toLowerCase()) >= 0
                //       );
                //     }
                //   }
                //   return (
                //     option?.children
                //       ?.toLowerCase()
                //       ?.indexOf(input?.toLowerCase()) >= 0
                //   );
                // }}
                defaultValue={item?.defaultValue}
              >
                {item?.data?.length &&
                  item?.data?.map((option, i) => {
                    return (
                      <Option key={i} value={option?.id ? option?.id : ""}>
                        {option?.start_location?.title} -{" "}
                        {option?.end_location?.title} ({option?.title})
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
        );
      });
    }
    return null;
  };

  const onChangeSearch = (e) => {
    form.resetFields();
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        setLoadingFilter(true);
        let data = { ...values };
        let from_date = null;
        let to_date = null;
        if (values?.range_picker) {
          from_date = JSON.stringify(
            formatAsISOString(values?.range_picker[0])
          );
          to_date = JSON.stringify(formatAsISOString(values?.range_picker[1]));
        }

        const filterUpdate = {};

        filterUpdate.start_date = from_date.substring(1, 11);
        filterUpdate.end_date = to_date.substring(1, 11);
        filterUpdate.route_id = values?.routes;

        delete data.range_picker;
        setFilter((filter) => {
          return {
            ...filter,
            ...filterUpdate,
          };
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <Form
        {...layout}
        form={form}
        onFinish={handleOk}
        name="control-hooks"
        style={{ maxWidth: 1000 }}
      >
        <Row type="flex" gutter={[16, 16]} justify={justify}>
          {createElement(data)}
          <Col sm={{ span: colTextSearch }} xs={{ span: 24 }}>
            <Form.Item name="range_picker">
              <RangePicker
                placeholder={["Start date", "End date"]}
                format={"DD-MM-YYYY"}
                style={{ width: "100%" }}
                // onChange={handleRangeChange}
              />
            </Form.Item>
          </Col>

          <Button
            htmlType="submit"
            style={{ background: "#14bb8c", color: "#FFF", cursor: "pointer" }}
            loading={loadingFilter}
          >
            <SearchOutlined />
          </Button>
        </Row>
      </Form>
    </>
  );
};

FilterBookingStatistic.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  textSearch: PropTypes.bool,
  onFilter: PropTypes.func,
  searchOption: PropTypes.object,
  justify: PropTypes.oneOf(["start", "end", "center", "space-between"]),
  showActionBar: PropTypes.bool,
  colTextSearch: PropTypes.number,
};

FilterBookingStatistic.defaultProps = {
  data: [],
  onFilter: () => {},
  textSearch: true,
  searchOption: {},
  justify: "start",
  showActionBar: true,
  colTextSearch: 6,
};

export default FilterBookingStatistic;
